"use client";
import { useState } from "react";

export type ToggleButtonProperties = {
  className?: string | undefined;
  label: string;
};
export const ToggleButton = ({
  className = "",
  label,
}: ToggleButtonProperties) => {
  const [open, setOpen] = useState(false);

  return (
    <button
      aria-expanded={open}
      aria-label={label}
      className={className}
      onClick={() => {
        setOpen((open) => !open);
      }}
    >
      <svg
        className="*:transition-all"
        height="24"
        viewBox="0 0 24 24"
        width="24"
      >
        <path
          d={open ? "M12.5 12.5 L 12.5 12.5" : "M0 6 L24 6"}
          fill="transparent"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d={open ? "M12.5 12.5 L 12.5 12.5" : "M0 18 L24 18"}
          fill="transparent"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d={open ? "M4.5 4.5 L 20.5 20.5" : "M0 12 L24 12"}
          fill="transparent"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d={open ? "M4.5 20.5 L 20.5 4.5" : "M0 12 L24 12"}
          fill="transparent"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </svg>
    </button>
  );
};
